export default "__VITE_ASSET__0dd10d5f__"